import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, MenuItem, Tooltip } from '@mui/material';

type SocialExportPublishPlatformMenuItemProps = {
  platform: SocialPlatform;
  /** Restriction message when publishing to this platform is not allowed. */
  restrictionMessage?: string;
  onSelect: (platformId: string) => void;
};

/**
 * Single platform entry in the publish menu; disabled with a warning when restricted.
 */
export function SocialExportPublishPlatformMenuItem({
  platform,
  restrictionMessage,
  onSelect,
}: SocialExportPublishPlatformMenuItemProps) {
  const isRestricted = Boolean(restrictionMessage);

  const menuItem = (
    <MenuItem disabled={isRestricted} onClick={() => onSelect(platform.id)}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          gap: 1,
        }}
      >
        {platform.Icon({ sx: { fontSize: 20 }, colored: true })}
        <Box sx={{ flexGrow: 1 }}>{platform.name}</Box>
        {restrictionMessage ? <WarningAmberRoundedIcon fontSize="small" color="warning" /> : null}
      </Box>
    </MenuItem>
  );

  if (!restrictionMessage) {
    return menuItem;
  }

  // Span wrapper so the tooltip receives hover even when the MenuItem is disabled.
  return (
    <Tooltip title={restrictionMessage} placement="right">
      <Box component="span" sx={{ display: 'block' }}>
        {menuItem}
      </Box>
    </Tooltip>
  );
}
